import { hasAnyTranslation, translateBackend } from '@assets/i18n/config';
import { Card, CardContent } from '@ovComponents/2-component/card/card';
import { sanitizeRichTextHtml } from '@utils/sanitizeRichTextHtml';
import { Box, Typography, useTheme } from 'hephaestus/web';

export const FreeformInput = ({ options = {} }: { options?: any }) => {
  const theme = useTheme();
  const disableQuill = options?.disableQuill ?? false;
  const fontFamily = theme.font.base;

  const htmlRenderer = (component: JSX.Element) => {
    switch (options.showInCard) {
      case true:
        return (
          <Card variant='elevated'>
            <CardContent
              sx={{
                overflow: 'auto',
                '&:last-child': { paddingBottom: '16px' },
              }}
            >
              {component}
            </CardContent>
          </Card>
        );
      default:
        return (
          <Box
            sx={{
              overflow: 'auto',
            }}
          >
            {component}
          </Box>
        );
    }
  };

  // Get the template content directly from options without fetching/filling
  const getTemplateContent = () => {
    if (hasAnyTranslation(options.template)) {
      const decoded = atob(translateBackend(options.template));
      return decoded;
    }
    return '';
  };

  return (
    <Box className='ql-snow'>
      <style>
        {`
          .ql-editor {
            font-family: ${fontFamily};
          }

          .ql-editor p, .ql-editor td  {
            font-size: 14px;
            line-height: 20px;
            font-weight: 400;
            letter-spacing: 0.25px;
          }
          .ql-editor p .ql-size-small, .ql-editor td .ql-size-small {
            font-size: 12px;
            line-height: 16px;
            font-weight: 400;
            letter-spacing: 0.25px;
          }
          .ql-editor p .ql-size-large, .ql-editor td .ql-size-large {
            font-size: 16px;
            line-height: 24px;
            letter-spacing: 0.25px;
            font-weight: 500;
          }
          .ql-editor p .ql-size-huge, .ql-editor td .ql-size-huge {
            font-size: 20px;
            line-height: 32px;
            letter-spacing: 1px;
            font-weight: 500;
          }
          .ql-editor p strong, .ql-editor td strong {
            font-weight: 600 !important;
          }
          .ql-editor h1, .ql-editor h2, .ql-editor h3,
          .ql-editor h4, .ql-editor h5, .ql-editor h6 {
            font-weight: 600;
          }
          .ql-editor h1 strong, .ql-editor h2 strong, .ql-editor h3 strong,
          .ql-editor h4 strong, .ql-editor h5 strong, .ql-editor h6 strong {
            font-weight: 700 !important;
          }
        `}
      </style>

      {translateBackend(options.customTitle) !== '' && (
        <Box
          sx={{
            display: 'flex',
            pb: 2,
          }}
        >
          <Typography variant='headingSmall'>
            {translateBackend(options.customTitle)}
          </Typography>
        </Box>
      )}

      {htmlRenderer(
        <Box
          className={disableQuill ? undefined : 'ql-editor'}
          dangerouslySetInnerHTML={{
            __html: sanitizeRichTextHtml(getTemplateContent()),
          }}
        />,
      )}
    </Box>
  );
};
